export const HEADER_HEIGHT = 88;

export const MOBILE_FOOTER_HEIGHT = 120;

export const DESKTOP_FOOTER_HEIGHT = 270;
